import { atom } from "jotai";

export const patientdetails = atom();
export const userid = atom();
export const userUserID = atom();
export const usernamephone = atom();
export const typesoffile = atom("");
export const senduserrecords = atom((get) => {
  const patientdetail = get(patientdetails);
  //("all records",patientdetail)
  const filetype = get(typesoffile);
  const patientdt = patientdetail?.map((ele) => ele?.user_records);
  //("all records get",patientdt)

  const extractedObjects = patientdt?.flatMap((sublist) =>
    sublist?.filter((item) => typeof item === "object" && item !== null)
  );
  //("all merge records",extractedObjects)
  const billrecord = extractedObjects?.filter(
    (obj) => obj?.type_of_file === filetype
  );

  return billrecord;
});
export const isuserside = atom(false);

export const existingUser = atom(false);
export const linkModal = atom(false);

export const userDataAtom = atom([]);

export const doctor_personal_details = atom([]);

export const linkedPharmacyAtom = atom([]);
